import { LayoutModule } from '@angular/cdk/layout';
import { CommonModule, DatePipe } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from './material.module';
import { CmsTableComponent } from './components/cms-table.component';
import { cmsTablePropertyKeyPipe } from './pipes/cms-table-property-key.pipe';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { FilterComponent } from './components/filters/filter.component';
import { TextComponent } from './components/filters/filters-type/text/text.component';
import { NumberComponent } from './components/filters/filters-type/number/number.component';
import { DateComponent } from './components/filters/filters-type/date/date.component';
import { SelectComponent } from './components/filters/filters-type/select/select.component';
import { DateRangeComponent } from './components/filters/filters-type/date-range/date-range.component';
import { NumberRangeComponent } from './components/filters/filters-type/number-range/number-range.component';

@NgModule({
  declarations: [
    CmsTableComponent,
    cmsTablePropertyKeyPipe,
    ConfirmationComponent,
    FilterComponent,
    TextComponent,
    NumberComponent,
    DateComponent,
    SelectComponent,
    DateRangeComponent,
    NumberRangeComponent,
  ],
  imports: [
    CommonModule,
    LayoutModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
  ],
  exports: [
    CommonModule,
    LayoutModule,
    MaterialModule,
    FlexLayoutModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    CmsTableComponent,
    cmsTablePropertyKeyPipe,
    FilterComponent,
    TextComponent,
    NumberComponent,
    DateComponent,
    SelectComponent,
    DateRangeComponent,
    NumberRangeComponent,
  ],
})
export class SharedModule { }
